export default {
  middleware_url: "https://tclm.fluid-it.fr",
  cake_url: "https://tclm.cake.fluid-it.fr",
  pwa_url: "https://app.tclm.fluid-it.fr",
  isWavesoftEnabled: false,
  billingConforamaEnabled: false,
  isUrbantzEnabled: false,
  showLockBillingButton: true,
  useRatingSystem: true,
  useMapPage: true,
  useGpsTracking: true,
  instancePrefix: "34",
  googleMap: {
    api: "AIzaSyArO8AubeViV__ATHoLEY88mtlRK_VyMzc",
  },
};
